import { render, staticRenderFns } from "./accepted.vue?vue&type=template&id=960d4b52&scoped=true&"
import script from "./accepted.vue?vue&type=script&lang=js&"
export * from "./accepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960d4b52",
  null
  
)

export default component.exports